// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

/**
 * 管理者権限が必要なルート用のガードコンポーネント
 * 未ログイン → /login にリダイレクト
 * 一般ユーザー → アクセス拒否メッセージ表示
 */
function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  // 認証状態の読み込み中
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // 未ログインの場合はログイン画面へリダイレクト
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 管理者権限がない場合はアクセス拒否画面を表示
  if (user.role !== 'admin') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          gap: 3,
          p: 3
        }}
      >
        <WarningIcon sx={{ fontSize: 80, color: 'warning.main' }} />
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
          アクセス権限がありません
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center', maxWidth: 500 }}>
          この画面は管理者のみアクセスできます。管理者権限が必要な場合は、システム管理者にお問い合わせください。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.href = '/home'}
          sx={{ mt: 2, px: 4 }}
        >
          ホームに戻る
        </Button>
      </Box>
    );
  }

  // 管理者の場合は子コンポーネントを表示
  return children;
}

export default AdminRoute;
